class PageMenuProductos extends HTMLElement {
  constructor() {
    super();

    const urlParams = new URLSearchParams(window.location.search);
    let coleccionParam = urlParams.get('coleccion') || 'Todo';

    // Normalizar nombres de colecciones que tienen caracteres especiales
    coleccionParam = this.normalizarNombreColeccion(coleccionParam);

    this.estadoVistaPagina = coleccionParam;

    // Sincronizar con localStorage para compatibilidad
    localStorage.setItem("phph-itemMenu", this.estadoVistaPagina);

    // Inicializar vacío, se llenará en connectedCallback
    this.cargaProgresiva = {
      coleccionesProcesadas: [],
      coleccionesPendientes: [],
      cargandoMas: false,
      tamanoLote: 3,
      observadorScroll: null,
    };

    this.sucursal = GestionSucursales.corroborarInfoShopify(
      window.sucursales,
      JSON.parse(localStorage.getItem("sucursal-informacion"))
    );
  }

  connectedCallback() {
    // PASO 1: Inicializar colecciones desde data-colecciones
    const coleccionesString = this.dataset.colecciones;

    if (coleccionesString) {
      // Separar por comas y limpiar espacios
      const coleccionesArray = coleccionesString
        .split(',')
        .map(col => col.trim())
        .filter(col => col && col !== "Todo");

      this.cargaProgresiva.coleccionesPendientes = coleccionesArray;

      console.log("✅ Colecciones cargadas:", this.cargaProgresiva.coleccionesPendientes);
    } else {
      console.warn("⚠️ No se encontró data-colecciones");
      this.cargaProgresiva.coleccionesPendientes = [];
    }

    // PASO 2: REFERENCIAS ELEMENTOS
    this.seccionGeneralPagina = this.querySelector("#phpm-seccion-general-page");
    this.menuContainer = this.querySelector(".phpm-items-menu");
    this.opcionesMenu = null;
    this.botonIzquierdaMenu = this.querySelector("#phpm-btn-izquierda-menu");
    this.botonDerechaMenu = this.querySelector("#phpm-btn-derecha-menu");

    this.cantidadDesplazamiento = 400;

    // PASO 3: EVENTOS INICIALIZAR
    this.botonIzquierdaMenu.addEventListener(
      "click",
      this.desplazarIzquierda.bind(this)
    );
    this.botonDerechaMenu.addEventListener(
      "click",
      this.desplazarDerecha.bind(this)
    );

    this.contruccionPaginaInformacion();
  }

  normalizarNombreColeccion(nombre) {
    // Si viene "Mitad" solo o "Mitad " con espacio, completar a "Mitad & Mitad"
    if (nombre === 'Mitad' || nombre.trim() === 'Mitad') {
      return 'Mitad & Mitad';
    }

    // Aquí puedes agregar más casos si surgen en el futuro
    // if (nombre === 'Otro') return 'Otro & Caso';

    return nombre;
  }

  async contruccionPaginaInformacion() {
    await this.construccionCabezera();
    await this.construccionCuerpo();
  }

  async construccionCabezera() {
    this.opcionesMenu = this.querySelectorAll(".page-menu-opcion");
    this.opcionesMenu.forEach((elementoItemMenu) => {
      elementoItemMenu.addEventListener(
        "click",
        this.seleccionItemMenu.bind(this, elementoItemMenu)
      );
    });

    this.opcionesMenu.forEach((elementoItemMenu) => {
      if (this.estadoVistaPagina == elementoItemMenu.dataset.categoria) {
        elementoItemMenu.classList.add("seleccionado");
        // elementoItemMenu.scrollIntoView({
        //   behavior: "smooth",
        //   block: "center",
        //   inline: "center",
        // });
        this.scrollItemIntoView(elementoItemMenu);
      } else {
        elementoItemMenu.classList.remove("seleccionado");
      }
    });

    this.verificarBotones();
  }

  /**
 * Desplaza el menú horizontal para centrar el ítem seleccionado.
 * Usa scrollLeft del contenedor para NO mover el body/documento.
 */
  scrollItemIntoView(elementoItemMenu) {
    if (!this.menuContainer) return;
    const container = this.menuContainer;
    const itemRect = elementoItemMenu.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const scrollLeft = container.scrollLeft;
    const itemPositionInContent = scrollLeft + (itemRect.left - containerRect.left);
    const itemWidth = itemRect.width;
    const containerWidth = containerRect.width;
    const targetScroll = itemPositionInContent - (containerWidth / 2) + (itemWidth / 2);
    container.scrollTo({
      left: Math.max(0, Math.min(targetScroll, container.scrollWidth - containerWidth)),
      behavior: "smooth"
    });
  }

  seleccionItemMenu(elementoBase) {
    // TODO - OFERTAS - PIZZAS - POSTRES etc.
    const dataSeccion = elementoBase.dataset.categoria;
    this.estadoVistaPagina = dataSeccion;

    // Limpiar observador de scroll si existe
    if (this.cargaProgresiva.observadorScroll) {
      this.cargaProgresiva.observadorScroll.disconnect();
      this.cargaProgresiva.observadorScroll = null;
    }

    this.opcionesMenu.forEach((elementoItemMenu) => {
      if (elementoItemMenu == elementoBase) {
        elementoItemMenu.classList.add("seleccionado");
        // elementoItemMenu.scrollIntoView({
        //   behavior: "smooth",
        //   block: "center",
        //   inline: "center",
        // });
        this.scrollItemIntoView(elementoItemMenu);
      } else {
        elementoItemMenu.classList.remove("seleccionado");
      }
    });
    this.construccionCuerpo();


    // Actualizar la URL con el nuevo parámetro (sin recargar la página)
    const nuevaURL = `/pages/_menu-1?coleccion=${encodeURIComponent(dataSeccion)}`;
    window.history.pushState({ coleccion: dataSeccion }, '', nuevaURL);

    // Sincronizar con localStorage para compatibilidad
    localStorage.setItem("phph-itemMenu", dataSeccion);
  }

  async construccionCuerpo() {
    MensajeCargaDatos.mostrar("Cargando colección...");

    const seccionHTML = this.querySelector(
      `[data-tiposeccion="${this.estadoVistaPagina}"]`
    );

    if (!seccionHTML) {
      console.error(
        "❌ No se encontró seccionHTML para:",
        this.estadoVistaPagina
      );
      MensajeCargaDatos.ocultar();
      return;
    }

    // Limpiar observador cuando cambias de vista (excepto si es Todo)
    if (
      this.estadoVistaPagina !== "Todo" &&
      this.cargaProgresiva.observadorScroll
    ) {
      this.cargaProgresiva.observadorScroll.disconnect();
      this.cargaProgresiva.observadorScroll = null;
    }

    // VERIFICAR SI YA ESTÁ CARGADA
    if (seccionHTML.dataset.cargada === "si") {
      this.mostrarSeccionCorrecta();
      this.inicializarEventosYElementosSeccion();
      MensajeCargaDatos.ocultar();
      return;
    }

    // SI NO ESTÁ CARGADA, CARGAR DATOS
    if (this.estadoVistaPagina === "Todo") {
      await this.cargarVistaCompleta(seccionHTML);
    } else {
      await this.cargarColeccionEspecifica(seccionHTML);
    }

    // Marcar como cargada y mostrar
    seccionHTML.dataset.cargada = "si";
    this.mostrarSeccionCorrecta();
    this.inicializarEventosYElementosSeccion();
    MensajeCargaDatos.ocultar();
    console.log("Testingzzzz :", this.cargaProgresiva.coleccionesProcesadas);
  }

  // FUNCIÓN PARA MOSTRAR/OCULTAR SECCIONES
  mostrarSeccionCorrecta() {
    const todasLasSecciones = this.querySelectorAll("[data-tiposeccion]");
    if (!todasLasSecciones || todasLasSecciones.length === 0) {
      console.warn("⚠️ No se encontraron secciones de productos");
      return;
    }

    todasLasSecciones.forEach((seccion) => {
      if (seccion.dataset.tiposeccion == this.estadoVistaPagina) {
        seccion.style.display = "flex";
      } else {
        seccion.style.display = "none";
      }
    });
  }

  async cargarVistaCompleta(seccionHTML) {
    // Limpiar las comillas de los nombres de colecciones (si aún existen)
    this.cargaProgresiva.coleccionesPendientes =
      this.cargaProgresiva.coleccionesPendientes.map((col) =>
        col.replace(/"/g, "").trim()
      );

    // Sacar las siguientes colecciones de pendientes
    const coleccionesACargar = this.cargaProgresiva.coleccionesPendientes.splice(0, this.cargaProgresiva.tamanoLote);

    if (coleccionesACargar.length == 0) return;

    try {
      // Cargar esas colecciones
      const coleccionesCargadas = await GestorProductos.obtenerProductosDeColecciones(coleccionesACargar);

      if (!coleccionesCargadas || coleccionesCargadas.length === 0) {
        console.error("❌ No se pudieron cargar las colecciones");
        return;
      }

      // Filtrar productos por sucursal y stock
      coleccionesCargadas.forEach((coleccion) => {
        if (coleccion.productos && coleccion.productos.length > 0) {
          coleccion.productos = this.filtrarProductosPorSucursal(coleccion.productos);
          console.log(`Colección ${coleccion.nombre}: ${coleccion.productos.length} productos con stock`);
        }
      });

      // Moverlas a procesadas
      this.cargaProgresiva.coleccionesProcesadas.push(...coleccionesCargadas);

      // Generar HTML de las colecciones
      let htmlColecciones = "";
      coleccionesCargadas.forEach((coleccion) => { htmlColecciones += this.generarHTMLColeccion(coleccion); });

      // Insertar en el DOM
      seccionHTML.insertAdjacentHTML("beforeend", htmlColecciones);

      // Renderizar productos de cada colección
      coleccionesCargadas.forEach((coleccion) => {
        this.renderizarProductosColeccion(coleccion, seccionHTML);
      });

      // Configurar observador de scroll si quedan colecciones pendientes
      if (this.cargaProgresiva.coleccionesPendientes.length > 0) {
        this.configurarCargaProgresiva(seccionHTML);
      } else {
        // Remover el observador si ya no hay más que cargar
        if (this.cargaProgresiva.observadorScroll) {
          this.cargaProgresiva.observadorScroll.disconnect();
          this.cargaProgresiva.observadorScroll = null;
        }
      }
    } catch (error) {
      console.error("💥 Error al cargar colecciones:", error);
    }
  }

  // Configurar observador de scroll para carga progresiva
  configurarCargaProgresiva(seccionHTML) {
    // Si ya hay un observador activo, no crear otro
    if (this.cargaProgresiva.observadorScroll) {
      return;
    }

    // Si ya se está cargando, no hacer nada
    if (this.cargaProgresiva.cargandoMas) {
      return;
    }

    // Crear un elemento "sentinel" (marcador) al final de la sección
    let sentinel = seccionHTML.querySelector(".phpm-sentinel-carga");

    if (!sentinel) {
      sentinel = document.createElement("div");
      sentinel.className = "phpm-sentinel-carga";
      sentinel.style.height = "100px";
      sentinel.style.width = "100%";
      seccionHTML.appendChild(sentinel);
    }

    // Configurar Intersection Observer
    this.cargaProgresiva.observadorScroll = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Si el sentinel es visible (usuario llegó al final)
          if (entry.isIntersecting && !this.cargaProgresiva.cargandoMas) {
            this.cargarMasColecciones(seccionHTML);
          }
        });
      },
      {
        root: null, // Usar el viewport como raíz
        rootMargin: "200px", // Cargar cuando esté a 200px del final
        threshold: 0.1, // Disparar cuando 10% del elemento sea visible
      }
    );

    // Observar el elemento sentinel
    this.cargaProgresiva.observadorScroll.observe(sentinel);
  }

  // Cargar más colecciones cuando el usuario llega al final
  async cargarMasColecciones(seccionHTML) {
    // Evitar cargas múltiples simultáneas
    if (this.cargaProgresiva.cargandoMas) {
      console.warn("⏳ Ya se está cargando, esperando...");
      return;
    }

    // Si no hay colecciones pendientes, no hacer nada
    if (this.cargaProgresiva.coleccionesPendientes.length === 0) {
      if (this.cargaProgresiva.observadorScroll) {
        this.cargaProgresiva.observadorScroll.disconnect();
        this.cargaProgresiva.observadorScroll = null;
      }
      return;
    }

    this.cargaProgresiva.cargandoMas = true;
    MensajeCargaDatos.mostrar("Cargando más productos...");

    try {
      // Cargar las siguientes 3 colecciones
      await this.cargarVistaCompleta(seccionHTML);
    } catch (error) {
      console.error("💥 Error al cargar más colecciones:", error);
    } finally {
      this.cargaProgresiva.cargandoMas = false;
      MensajeCargaDatos.ocultar();
    }
  }

  // CARGAR COLECCIÓN ESPECÍFICA
  async cargarColeccionEspecifica(seccionHTML) {
    try {
      // Cargar datos de la colección
      const coleccionesCargadas = await GestorProductos.obtenerProductosDeColecciones([this.estadoVistaPagina]);

      // Validar que se cargaron colecciones
      if (!coleccionesCargadas || coleccionesCargadas.length === 0) {
        console.error('❌ No se pudieron cargar colecciones para:', this.estadoVistaPagina);
        return;
      }

      // Filtrar productos por sucursal y stock
      coleccionesCargadas.forEach((coleccion) => {
        if (coleccion.productos && coleccion.productos.length > 0) {
          coleccion.productos = this.filtrarProductosPorSucursal(coleccion.productos);
          console.log(`Colección ${coleccion.nombre}: ${coleccion.productos.length} productos con stock`);
        }
      });

      // Mover a procesadas
      this.cargaProgresiva.coleccionesProcesadas.push(...coleccionesCargadas);

      const coleccionTrabajo = coleccionesCargadas.find((coleccion) => coleccion.nombre === this.estadoVistaPagina);

      if (!coleccionTrabajo) {
        console.error('❌ No se encontró la colección:', this.estadoVistaPagina);
        console.error('❌ Colecciones disponibles:', coleccionesCargadas.map((c) => c.nombre));
        return;
      }

      if (!coleccionTrabajo.productos || coleccionTrabajo.productos.length === 0) {
        console.warn('⚠️ La colección no tiene productos:', this.estadoVistaPagina);
        return;
      }

      // Generar y insertar HTML
      const htmlColeccion = this.generarHTMLColeccion(coleccionTrabajo);
      seccionHTML.insertAdjacentHTML("beforeend", htmlColeccion);

      // Renderizar productos
      this.renderizarProductosColeccion(coleccionTrabajo, seccionHTML);
    } catch (error) {
      console.error("💥 Error al cargar colección específica:", error);
      console.error("💥 Stack:", error.stack);
    }
  }

  // GENERAR HTML DE UNA COLECCIÓN
  generarHTMLColeccion(coleccion) {
    return `
    <div id="coleccion-titulo" data-titulo="${coleccion.nombre}" class="phpm-titulo-primario">
      <small>${coleccion.nombre}</small>
    </div>
    <div data-titulo="${coleccion.nombre}" class="phpm-seccion">
      <div id="producto-coleccion" class="phpm-items container-base">
      </div>
    </div>
  `;
  }

  // RENDERIZAR PRODUCTOS DE UNA COLECCIÓN
  renderizarProductosColeccion(coleccion, seccionBase = null) {
    let productoSeccionHTML = "";

    // Filtrar productos con metafield

    // Validar que hay productos
    if (!coleccion.productos || coleccion.productos.length === 0) {
      console.warn("⚠️ No hay productos para renderizar en:", coleccion.nombre);
      return;
    }

    coleccion.productos.forEach((producto) => {
      const html = this.procesarProducto(producto, coleccion);
      if (html) {
        productoSeccionHTML += html;
      }
    });

    const contenedorBusqueda = seccionBase || this;
    const seccionProductos = contenedorBusqueda.querySelector(
      `[data-titulo="${coleccion.nombre}"] #producto-coleccion`
    );

    if (seccionProductos) {
      seccionProductos.insertAdjacentHTML("beforeend", productoSeccionHTML);
    } else {
      console.error(
        "❌ No se encontró la sección de productos para:",
        coleccion.nombre
      );
    }
  }

  //  Genera el HTML para las variantes de tamaño de un producto
  generarHTMLVariantes(seccionTamano, variantePreSeleccionada) {
    let contenidoVariantes = "";
    seccionTamano.forEach((tamano) => {
      const esSeleccionado = variantePreSeleccionada === tamano ? "seleccionado" : "";
      contenidoVariantes += `
        <div 
          data-id="${tamano.id}"
          class="variante-producto-item ${esSeleccionado}">
          <p>${this.acortarTitulo(tamano.titulo)}</p>
          <p class="color-letras-primary">${parseInt(tamano.precio)} Bs</p>
        </div>
      `;
    });
    return contenidoVariantes;
  }

  // Genera el HTML para producto personalizable tipo Pizza
  generarHTMLProductoPizza(
    producto,
    coleccion,
    variantePreSeleccionada,
    contenidoVariantes
  ) {
    const estiloDescripcion = GestorProductos.estiloTituloProducto(
      producto.nombre
    );

    return `
    <div 
      data-idshopify="${producto.idshopify}"
      data-idtrabajo="${producto.idtrabajo}"
      data-handle="${producto.handle}"
      data-nombre="${producto.nombre}"
      data-precio="${producto.precio}"
      data-seleccionado="${variantePreSeleccionada.id}"
      data-tipoproducto="complejo" class="producto-es-item">
      <div 
        style="${variantePreSeleccionada.precio_comparacion > 0
        ? "display: flex;"
        : "display: none;"
      }"
        class="producto-es-item-descuento">
        <p>
          ${variantePreSeleccionada.precio_comparacion > 0
        ? GestorProductos.calcularDescuento(
          variantePreSeleccionada.precio,
          variantePreSeleccionada.precio_comparacion
        )
        : ""
      }
        </p>
      </div>
      <div class="producto-es-item-imagen">
        <img src="${producto.imagen}" alt="${producto.nombre
      }" width="100%" height="100%">
      </div>
      <div class="producto-es-item-detalle">
        <div class="producto-es-item-info">
          <h3>${producto.nombre}</h3>
          <p style="${estiloDescripcion}">${producto.descripcion}</p>
        </div>
        <div class="producto-es-item-precios">
          <h3 class="color-letras-primary">${parseInt(
        variantePreSeleccionada.precio
      )} BS</h3>
          <h4 class="color-letras-precioCS">
            ${variantePreSeleccionada.precio_comparacion > 0
        ? `${parseInt(variantePreSeleccionada.precio_comparacion)} BS`
        : ""
      }
          </h4>
        </div>
        <div id="phpm-general-variantes" class="phpg-svpg-pcl seleccion-variante-producto-general">
          <p>Tamaño</p>
          <button id="phpm-view-variantes" class="container-info-variante">
            <p class="color-letras-tertiary" id="phpm-variante-seleccionado">${this.acortarTitulo(
        variantePreSeleccionada.titulo
      )}</p>
            <div class="icono-dropdown-variantes icon-color-tertiary">
              ${window.shopIcons.icon_flecha_abajo}
            </div>
          </button>
          <div id="phpm-items-variantes" class="variantes-producto" style="display: none;">
            ${contenidoVariantes}
          </div>
        </div>
        <button id="phpm-btn-personalizar" class="ph-btn-general phpm-btn-personalizar">
          <p class="color-letras-secondary">PERSONALIZAR</p>
        </button>
      </div>
    </div>
  `;
  }

  // Genera el HTML para producto personalizable NO Pizza
  generarHTMLProductoPersonalizableNoPizza(producto, coleccion) {
    const estiloDescripcion = GestorProductos.estiloTituloProducto(
      producto.nombre
    );

    return `
    <div 
      data-codigo="${coleccion.nombre}"
      data-idshopify="${producto.idshopify}"
      data-idtrabajo="${producto.idtrabajo}"
      data-handle="${producto.handle}"
      data-titulo="${producto.nombre}"
      data-precio="${producto.precio}"
      data-tipoproducto="complejo" class="producto-es-item">
      ${producto.precio_comparacion > 0
        ? `
        <div class="producto-es-item-descuento">
          <p>${GestorProductos.calcularDescuento(
          producto.precio,
          producto.precio_comparacion
        )}</p>
        </div>
      `
        : ""
      }
      <div class="producto-es-item-imagen">
        <img src="${producto.imagen}" alt="${producto.nombre
      }" width="100%" height="100%"> 
      </div>
      <div class="producto-es-item-detalle">
        <div class="producto-es-item-info">
          <h3>${producto.nombre}</h3>
          <p style="${estiloDescripcion}">${producto.descripcion}</p>
        </div>
        <div class="producto-es-item-precios">
          ${coleccion.nombre !== "Mitad & Mitad"
        ? `<h3 class="color-letras-primary">${parseInt(
          producto.precio
        )} BS</h3>`
        : ""
      }                          
          ${producto.precio_comparacion > 0
        ? `
            <h4 class="color-letras-precioCS">${parseInt(
          producto.precio_comparacion
        )} BS</h4>
          `
        : ""
      }
        </div>
        <button id="phpm-btn-personalizar" class="ph-btn-general icon-color-secondary">
          <p class="color-letras-secondary">PERSONALIZAR</p>
        </button>
      </div>
    </div>
  `;
  }

  // Genera el HTML para producto básico (no personalizable)
  generarHTMLProductoBasico(producto, coleccion) {
    return `
    <div
      data-codigo="${coleccion.nombre}"
      data-idshopify="${producto.idshopify}"
      data-idtrabajo="${producto.idtrabajo}"
      data-titulo="${producto.nombre}"
      data-precio="${parseInt(producto.precio)}"
      data-handle="${producto.handle}"
      data-tipoproducto="basico" class="producto-es-item">
      <div class="producto-es-item-imagen">
        ${producto.precio_comparacion > 0
        ? `
          <div class="producto-es-item-descuento">
            <p>${GestorProductos.calcularDescuento(
          producto.precio,
          producto.precio_comparacion
        )}</p>
          </div>
        `
        : ""
      }
        <img src="${producto.imagen}" alt="${producto.nombre
      }" width="100%" height="100%">
      </div>
      <div class="producto-es-item-detalle">
        <div class="producto-item-info-es-basico">
          <h3>${producto.nombre}</h3>
        </div>
        <div class="producto-es-item-precios">
          <h3 class="color-letras-primary">${parseInt(producto.precio)} BS</h3>
          ${producto.precio_comparacion > 0
        ? `<h4 class="color-letras-precioCS">${parseInt(
          producto.precio_comparacion
        )} BS</h4>`
        : ""
      }
        </div>
        <button id="phpm-btn-agregar" class="ph-btn-general icon-color-secondary">
          ${window.shopIcons.icon_carrito}
          <p class="color-letras-secondary">AGREGAR</p>
        </button>
      </div>
    </div>
  `;
  }

  // Procesa y genera el HTML para un producto según su tipo
  procesarProducto(producto, coleccion) {
    // VALIDACION 1: Por fecha/dia (para todos los productos con metafield)
    if (producto.metafield && producto.metafield.dia) {
      const validacionFecha = GestorProductos.activacionProductoByDate(
        producto.metafield.dia
      );
      if (!validacionFecha.activado) {
        // No renderizar este producto
        console.log(
          `Producto ${producto.nombre} no disponible: ${validacionFecha.mensaje}`
        );
        return "";
      }
    }

    // CASO 1 : PRODUCTO PERSONALIZABLE
    if (producto.tags.includes("Personalizable")) {
      // Los personalizables SI necesistan metafield obligatoriamente
      if (!producto.metafield || Object.keys(producto.metafield).length === 0) {
        console.error(
          "❌ El producto personalizable no tiene metafield:",
          producto.nombre
        );
        return "";
      }

      // SUB CASO 1A : PIZZA PERSONALIZABLE
      if (producto.colecciones.some((col) => col.includes("Pizza"))) {

        const seccionTamano = producto.metafield.secciones.find((seccion) => seccion.titulo == "Tamaño" || seccion.key == "tamano");

        // Validar que existe seccion de tamanos
        if (!seccionTamano || !seccionTamano.productos || !Array.isArray(seccionTamano.productos)) {
          console.warn(`Pizza ${producto.nombre} no tiene sección de tamaños válida`);
          return "";
        }

        // VALIDACION 2 : Filtrar variantes por sucursales
        // Filtrar productos que tengan sucursales
        let variantesDisponibles = seccionTamano.productos.filter((producto) => producto.sucursales.length > 0);

        // Si hay sucursales seleccionada, filtrar solo los variantes de esa sucursal
        if (this.sucursal) {
          variantesDisponibles = variantesDisponibles.filter((producto) => producto.sucursales.includes(this.sucursal.id_publico));

          if (variantesDisponibles.length === 0) {
            // No renderizar si no hay variantes para la sucursal
            console.log(`Pizza ${producto.nombre} sin variantes para sucursal ${this.sucursal.nombre}`);
            return "";
          }
        }

        // Si despues de filtrar no quedan variantes, no renderizar
        if (variantesDisponibles.length === 0) {
          console.log(`Pizza ${producto.nombre} sin variantes disponibles`);
          return "";
        }

        // Usar las variantesfiltradas
        const variantePreSeleccionada = variantesDisponibles[0];
        const contenidoVariantes = this.generarHTMLVariantes(variantesDisponibles, variantePreSeleccionada);

        return this.generarHTMLProductoPizza(producto, coleccion, variantePreSeleccionada, contenidoVariantes);
      } else {
        // SUBCASO 1B : PRODUCTO PERSONALIZABLE NO PIZZA
        return this.generarHTMLProductoPersonalizableNoPizza(producto, coleccion);
      }
    } else {
      // CASO 2 : PRODUCTO BASICO
      return this.generarHTMLProductoBasico(producto, coleccion);
    }
  }

  // Filtramos productos segun sucursal seleccionada y stock disponible
  filtrarProductosPorSucursal(prod) {

    // Validacion Estado y StockTotal -> Shopify
    prod = prod.filter((producto) => {
      const tieneEstado = producto.estado;
      const tieneStock = producto.stockTotal > 0;
      const pasaFiltro = tieneEstado && tieneStock;
      return pasaFiltro;
    });

    // Si no hay sucursal seleccionada, retornar todos los productos
    if (!this.sucursal) {
      return prod;
    }

    // Validar que la sucursal esta activa
    const sucursalEnShopify = window.sucursales.find((s) => s.nombre == this.sucursal.nombre);

    // Si la sucursal no esta activa, no mostrar ningun producto
    if (!sucursalEnShopify?.estado) {
      console.log(`Sucursal ${this.sucursal.nombre} no está activa`);
      return [];
    }

    // Filtrar productos que tengan stock en la sucursal seleccionada
    return prod.filter((producto) => {
      // Buscar la sucursal en el producto
      const sucursalEnProducto = producto.sucursales.find((s) => s.nombre == this.sucursal.nombre);

      // Si no se encuentra la sucursal o no tiene stock, excluir el producto
      if (!sucursalEnProducto) {
        return false;
      }

      const stockDisponible = sucursalEnProducto.stock;
      return stockDisponible > 0;
    })
  }

  async inicializarEventosYElementosSeccion() {
    // REFERENCIAS ELEMENTOS
    this.contenedorGeneralProductos = this.querySelectorAll('.producto-es-item');
    this.contenedorVariantes = this.querySelectorAll('#phpm-items-variantes');
    this.contenedorVarianteSeleccionado = this.querySelectorAll('#phpm-view-variantes');
    this.varianteElemento = this.querySelectorAll('.variante-producto-item');
    this.btnsPersonalizarProducto = this.querySelectorAll('#phpm-btn-personalizar');
    this.btnsAgregarProducto = this.querySelectorAll('#phpm-btn-agregar');

    // EVENTOS PARA PRODUCTOS PERSONALIZABLES
    this.btnsPersonalizarProducto.forEach((boton) => {
      boton.addEventListener('click', () => {
        const productoHTML = boton.closest('.producto-es-item');
        const handle = productoHTML.dataset.handle;
        const varianteSeleccionada = productoHTML.dataset.seleccionado;
        const url = `/products/${handle}${varianteSeleccionada ? `?size=${varianteSeleccionada}` : ''}`;
        window.location.href = url;
      });
    });

    // EVENTOS PARA MOSTRAR/OCULTAR VARIANTES
    this.contenedorVarianteSeleccionado.forEach((boton) => {
      boton.addEventListener('click', this.mostrarYOcultarContenedorVariantes.bind(this, boton));
    });

    // EVENTOS PARA SELECCIONAR VARIANTE
    this.varianteElemento.forEach((variante) => {
      variante.addEventListener('click', () => {
        this.procesoVarianteSeleccionada(variante);
        // Cerrar el contenedor después de seleccionar
        const botonVariantes = variante.closest('#phpm-general-variantes').querySelector('#phpm-view-variantes');
        this.mostrarYOcultarContenedorVariantes(botonVariantes);
      });
    });

    // EVENTOS PARA PRODUCTOS BÁSICOS
    this.btnsAgregarProducto.forEach((boton) => {
      boton.addEventListener('click', this.procesoAgregarProducto.bind(this, boton));
    });

    // ===== NUEVO: EVENTOS PARA CLICK EN TÍTULO E IMAGEN =====
    this.contenedorGeneralProductos.forEach((productoHTML) => {
      const titulo = productoHTML.querySelector('.producto-es-item-info h3');
      const imagen = productoHTML.querySelector('.producto-es-item-imagen img');
      const handle = productoHTML.dataset.handle;

      // Agregar evento de click al título
      if (titulo && handle) {
        titulo.style.cursor = 'pointer';
        titulo.addEventListener('click', () => {
          const varianteSeleccionada = productoHTML.dataset.seleccionado;
          const url = `/products/${handle}${varianteSeleccionada ? `?size=${varianteSeleccionada}` : ''}`;
          window.location.href = url;
        });
      }

      // Agregar evento de click a la imagen
      if (imagen && handle) {
        imagen.style.cursor = 'pointer';
        imagen.addEventListener('click', () => {
          const varianteSeleccionada = productoHTML.dataset.seleccionado;
          const url = `/products/${handle}${varianteSeleccionada ? `?size=${varianteSeleccionada}` : ''}`;
          window.location.href = url;
        });
      }
    });
  }

  async procesoAgregarProducto(elementoBase) {
    const codigoColeccion =
      elementoBase.closest(".producto-es-item").dataset.codigo;
    const idShopify =
      elementoBase.closest(".producto-es-item").dataset.idshopify;
    const idTrabajo =
      elementoBase.closest(".producto-es-item").dataset.idtrabajo;

    const coleccionTrabajoRecuperada =
      this.estadoVistaPagina == "Todo"
        ? codigoColeccion == "Pizza Clasica" ||
          codigoColeccion == "Pizza Premium" ||
          codigoColeccion == "Pizza Grande" ||
          codigoColeccion == "Pizza Familiar"
          ? "Pizzas"
          : codigoColeccion
        : this.estadoVistaPagina;

    const infoCategoriaTrabajo = this.cargaProgresiva.coleccionesProcesadas.find(
      (coleccion) => coleccion.nombre == coleccionTrabajoRecuperada
    );
    const productoTrabajo = infoCategoriaTrabajo.productos.find(
      (producto) => producto.idshopify == idShopify
    );
    const detalleProducto = new ProductoCarrito({
      item_base: new ItemCarrito({
        idshopify: productoTrabajo.idshopify,
        idtrabajo: productoTrabajo.idtrabajo,
        nombre: productoTrabajo.nombre,
        precio: parseInt(productoTrabajo.precio),
        cantidad: 1,
        imagen: productoTrabajo.imagen,
        precio_conjunto: parseInt(productoTrabajo.precio) * 1,
        sucursales: productoTrabajo.sucursales,
        stockTotal: productoTrabajo.stockTotal,
        tipoProducto: "basico",
      }),
      items_principales: {
        titulo: "Opciones Principales",
        productos: [],
      },
      colecciones_trabajo: [`${codigoColeccion}`],
    });

    var productoCoincidente = null;

    this.carritoShopify = await AuxiliaresGlobal.obtenerCarritoShopify();

    if (this.carritoShopify.informacionCompleta.items.length == 0) {
      await AuxiliaresGlobal.agregarCarrito(
        1,
        parseInt(detalleProducto.item_base.idshopify),
        {
          properties: { estructura: JSON.stringify(detalleProducto) },
        }
      );
    } else {
      // Si el carrito tiene items, tienen se va buscar un elemento similar para
      // aumentar la cantidad de productos (complementos princiales o extras)
      this.carritoShopify.informacionCompleta.items.forEach((item) => {
        if (!item.properties?.estructura) return;
        try {
          const info = JSON.parse(item.properties.estructura);
          const det = detalleProducto;

          // Verificar producto principal
          if (
            info.item_base.idshopify != det.item_base.idshopify ||
            info.item_base.idtrabajo != det.item_base.idtrabajo
          )
            return;

          // Si todo coincide, guardar y salir
          productoCoincidente = item;
          return;
        } catch (error) {
          console.error("Error al analizar JSON:", error);
        }
      });

      // Si el producto que se prentende agregar no coincide tons se agrega normalmente
      // como un produto completamente nuevo
      if (productoCoincidente == null) {
        console.log(
          "No se encontró un producto coincidente, agregando nuevo producto al carrito.",
          {
            productoTrabajo: productoTrabajo,
            detalleProducto: detalleProducto,
          }
        );

        await AuxiliaresGlobal.agregarCarrito(
          1,
          parseInt(productoTrabajo.idshopify),
          {
            properties: { estructura: JSON.stringify(detalleProducto) },
          }
        );
      } else {
        await AuxiliaresGlobal.eliminarItemCarritoPorKey(
          productoCoincidente.key,
          0
        );
        const infoEstructura = JSON.parse(
          productoCoincidente.properties.estructura
        );
        infoEstructura.item_base.cantidad = `${parseInt(infoEstructura.item_base.cantidad) + 1
          }`;
        infoEstructura.item_base.precioTotalConjunto =
          parseInt(infoEstructura.item_base.cantidad) *
          parseInt(infoEstructura.item_base.precio);
        productoCoincidente.properties.estructura =
          JSON.stringify(infoEstructura);
        console.log(
          "Producto coincidente encontrado, actualizando cantidad y precio:",
          {
            productoCoincidente: productoCoincidente,
            infoEstructura: infoEstructura,
          }
        );
        await AuxiliaresGlobal.agregarCarrito(
          parseInt(infoEstructura.item_base.cantidad),
          parseInt(infoEstructura.item_base.idshopify),
          {
            properties: {
              estructura: productoCoincidente.properties.estructura,
            },
          }
        );
      }
    }

    MensajeCargaDatos.ocultar();
  }

  mostrarYOcultarContenedorVariantes(elementoBase) {
    const elementoPadre = elementoBase.closest("#phpm-general-variantes");
    const hermano = elementoPadre.querySelector("#phpm-items-variantes");
    const productoHTML = elementoBase.closest('.producto-es-item');

    // Usar clases CSS en lugar de style.display
    const estaVisible = hermano.classList.contains("elemento-visible");

    if (estaVisible) {
      hermano.classList.remove("elemento-visible");
      hermano.classList.add("elemento-oculto");
    } else {
      hermano.classList.remove("elemento-oculto");
      hermano.classList.add("elemento-visible");
    }

    // Ocultar otros contenedores de variantes
    const todosLosElementos = this.querySelectorAll("#phpm-items-variantes");
    todosLosElementos.forEach((elemento) => {
      if (elemento !== hermano) {
        elemento.classList.remove("elemento-visible");
        elemento.classList.add("elemento-oculto");
      }
    });

    // Cerrar al hacer click fuera
    if (!estaVisible) {  // Si acabamos de abrir
      const cerrarAlClickExterno = (evento) => {
        if (!productoHTML.contains(evento.target)) {
          hermano.classList.remove("elemento-visible");
          hermano.classList.add("elemento-oculto");
          document.removeEventListener("click", cerrarAlClickExterno);
        }
      };

      setTimeout(
        () => document.addEventListener("click", cerrarAlClickExterno),
        100
      );
    }
  }

  procesoVarianteSeleccionada(elementoVarianteSeleccionada) {
    // PASO 1 : Obtener el contenedor del producto
    const productoHTML = elementoVarianteSeleccionada.closest('.producto-es-item');

    // PASO 2 : Extraer el titulo de la variante seleccionada
    const textoTituloVariante = elementoVarianteSeleccionada.querySelector('p:nth-of-type(1)').textContent;

    // PASO 3 : Obtener el ID de Shopify del producto
    const idShopify = productoHTML.dataset.idshopify;

    // PASO 4 : Buscar el producto en las colecciones procesadas
    let productoEncontrado = null;
    let sizesProducto = null;

    for (const coleccion of this.cargaProgresiva.coleccionesProcesadas) {
      productoEncontrado = coleccion.productos.find((producto) => producto.idshopify == idShopify);
      if (productoEncontrado) {
        sizesProducto = productoEncontrado.metafield?.secciones
          ?.find((seccion) => seccion.titulo == "Tamaño" || seccion.key == "tamano");
        break;
      }
    }

    if (!sizesProducto || !sizesProducto.productos) {
      console.warn("No se encontraron tamaños para el producto");
      return;
    }

    // PASO 5 : Buscar la variante correspondiente en los datos
    const varianteEncontrada = sizesProducto.productos.find((producto) => producto.titulo.includes(textoTituloVariante));

    if (!varianteEncontrada) {
      console.warn("No se encontró la variante correspondiente");
      return;
    }

    // PASO 6: Actualizar seleccion visual
    const variantes = productoHTML.querySelectorAll(".variante-producto-item");
    variantes.forEach(v => v.classList.remove("seleccionado"));
    elementoVarianteSeleccionada.classList.add("seleccionado");

    // PASO 7: Cachear elementos del DOM
    const etiquetaHTMLVarianteSeleccionada = productoHTML.querySelector("#phpm-variante-seleccionado");
    const descuentoHTML = productoHTML.querySelector(".producto-es-item-descuento");
    const contenedorPrecios = productoHTML.querySelector(".producto-es-item-precios");
    const precioHTML = contenedorPrecios?.children?.[0] || null;
    const precioComparacionHTML = contenedorPrecios?.children?.[1] || null;


    // PASO 8: Actualizar descuento
    if (descuentoHTML) {
      descuentoHTML.style.display = varianteEncontrada.precio_comparacion > 0 ? "flex" : "none";
      if (varianteEncontrada.precio_comparacion > 0) {
        descuentoHTML.querySelector("p").innerHTML = GestorProductos.calcularDescuento(
          varianteEncontrada.precio,
          varianteEncontrada.precio_comparacion
        );
      }
    }

    // PASO 9: Actualizar precios
    if (precioHTML) {
      precioHTML.innerHTML = parseInt(varianteEncontrada.precio) + " BS";
    }
    if (precioComparacionHTML) {
      precioComparacionHTML.style.display = varianteEncontrada.precio_comparacion > 0 ? "flex" : "none";
      if (varianteEncontrada.precio_comparacion > 0) {
        precioComparacionHTML.innerHTML = parseInt(varianteEncontrada.precio_comparacion) + " BS";
      }
    }

    // PASO 10: Actualizar etiqueta de variante seleccionada
    if (etiquetaHTMLVarianteSeleccionada) {
      etiquetaHTMLVarianteSeleccionada.innerHTML = this.acortarTitulo(varianteEncontrada.titulo);
    }

    // PASO 11: Guardar ID de la variante seleccionada en el dataset
    productoHTML.dataset.seleccionado = varianteEncontrada.id;

  }

  agregarCarrito() {
    AuxiliaresGlobal.agregarCarrito(1);
    console.log("Agregado al carrito");
  }

  acortarTitulo(titulo) {
    if (titulo.includes("Clasica")) {
      return "Clasica";
    } else if (titulo.includes("Premium")) {
      return "Premium";
    } else if (titulo.includes("Grande")) {
      return "Grande";
    } else {
      return titulo;
    }
  }

  // Método para desplazar a la izquierda
  desplazarIzquierda() {
    console.log("Desplazando a la izquierda");

    // Verifica que el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Desplaza el contenedor
    this.menuContainer.scrollBy({
      left: -this.cantidadDesplazamiento,
      behavior: "smooth",
    });

    // Verifica los botones después del desplazamiento
    setTimeout(() => this.verificarBotones(), 300);
  }

  // Método para desplazar a la derecha
  desplazarDerecha() {
    // Verifica que el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Desplaza el contenedor
    this.menuContainer.scrollBy({
      left: this.cantidadDesplazamiento,
      behavior: "smooth",
    });

    // Verifica los botones después del desplazamiento
    setTimeout(() => this.verificarBotones(), 300);
  }

  // Método para verificar la visibilidad de los botones
  verificarBotones() {
    // Verificar si el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Comprobar inicio
    if (this.menuContainer.scrollLeft <= 0) {
      this.botonIzquierdaMenu.style.opacity = "0.5";
      this.botonIzquierdaMenu.style.pointerEvents = "none";
    } else {
      this.botonIzquierdaMenu.style.opacity = "1";
      this.botonIzquierdaMenu.style.pointerEvents = "auto";
    }

    // Comprobar final
    if (
      this.menuContainer.scrollLeft + this.menuContainer.clientWidth >=
      this.menuContainer.scrollWidth - 10
    ) {
      this.botonDerechaMenu.style.opacity = "0.5";
      this.botonDerechaMenu.style.pointerEvents = "none";
    } else {
      this.botonDerechaMenu.style.opacity = "1";
      this.botonDerechaMenu.style.pointerEvents = "auto";
    }
  }
}

customElements.define("page-menu-productos", PageMenuProductos);